/** Readers for Unity-serialized component data (YAML scalars arrive as strings). */
import { num } from '../../model/unityProps.ts';
import type { RGBA, V2 } from './unity.ts';

export { num };

export function bool(v: any, def = false): boolean {
  if (v === undefined || v === null || v === '') return def;
  if (typeof v === 'boolean') return v;
  return String(v) !== '0' && String(v) !== 'false';
}

export function vec(v: any, def: V2 = { x: 0, y: 0 }): V2 {
  if (!v || typeof v !== 'object') return { ...def };
  return { x: num(v.x, def.x), y: num(v.y, def.y) };
}

export function rgba(v: any, def: RGBA = [1, 1, 1, 1]): RGBA {
  if (!v || typeof v !== 'object') return [...def] as RGBA;
  return [num(v.r, def[0]), num(v.g, def[1]), num(v.b, def[2]), num(v.a, def[3])];
}

export function list(v: any): any[] {
  return Array.isArray(v) ? v : [];
}

/** true for null object references ({fileID: 0} or missing) */
export function isNull(v: any): boolean {
  if (!v || typeof v !== 'object') return true;
  if (v.entity || v.ref) return false;
  return v.fileID === undefined || String(v.fileID) === '0';
}
